const rootArea = "/identifiers";

export const identifiersGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (identifierTypeCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${identifierTypeCode}/read`,
		create: `${baseArea}${rootArea}/${identifierTypeCode}/create`,
		update: `${baseArea}${rootArea}/${identifierTypeCode}/update`,
		deactivate: `${baseArea}${rootArea}/${identifierTypeCode}/deactivate`,
		reactivate: `${baseArea}${rootArea}/${identifierTypeCode}/reactivate`
	})
});